module.exports = __webpack_public_path__ + "img/memory.8f2c872b.svg";